import { Link } from 'react-router-dom';
import { VERTICAL_LINKS } from '../data/verticalLinks';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-slate-200 bg-slate-50">
      <div className="container-custom py-12">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">

          {/* Brand */}
          <div>
            <img src="/logos/logo.png" alt="IDGate" className="h-44 w-auto" />
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">
              Trusted identity verification for regulated check-in workflows — so
              your front desk and your compliance team stay aligned.
            </p>
          </div>

          {/* Product */}
          <div>
            <p className="text-sm font-semibold text-slate-900">Product</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a href="/#how" className="text-slate-600 hover:text-primary-700">How it works</a></li>
              <li><a href="/#for-operators" className="text-slate-600 hover:text-primary-700">For your team</a></li>
              <li><a href="/#integrate" className="text-slate-600 hover:text-primary-700">Integrate</a></li>
              <li><Link to="/demo" className="text-slate-600 hover:text-primary-700">Try demo</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-primary-700">Contact</Link></li>
            </ul>
          </div>

          {/* Verticals — 2-col inner grid */}
          <div className="lg:col-span-2">
            <p className="text-sm font-semibold text-slate-900">Sectors</p>
            <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
              {VERTICAL_LINKS.map(v => (
                <li key={v.path}>
                  <Link to={v.path} className="text-slate-600 hover:text-primary-700">
                    {v.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom row: legal + copyright */}
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 text-sm text-slate-500 sm:flex-row sm:items-center">
          <p>© {year} IDGate. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/about" className="hover:text-slate-700">About</Link>
            <Link to="/privacy" className="hover:text-slate-700">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-700">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
